import ArtigoPlaceholder from "@/components/feature/ArtigoPlaceholder";
export default function ArtigoWeidian() {
  return (
    <ArtigoPlaceholder
      title="Melhores Lojas Weidian para Usar com CSSBuy Spreadsheet em 2026"
      desc="Lista atualizada das lojas Weidian mais confiáveis para comprar tênis, roupas e acessórios. Avaliações reais e dicas para não cair em golpes."
      icon="ri-store-2-line"
      slug="artigo-cssbuy-weidian"
    />
  );
}